document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-mobile-menu-toggle]');
  if (menuToggle) {
    const drawer = document.querySelector('[data-mobile-menu]');
    if (drawer) {
      const isOpen = drawer.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    }
  }

  const accordionTrigger = event.target.closest('[data-accordion-trigger]');
  if (accordionTrigger) {
    const item = accordionTrigger.closest('.accordion-item');
    if (item) {
      const isOpen = item.classList.toggle('is-open');
      accordionTrigger.setAttribute('aria-expanded', String(isOpen));
    }
  }

  const qtyButton = event.target.closest('[data-qty-button]');
  if (qtyButton) {
    const input = qtyButton.parentElement.querySelector('input');
    if (!input) return;
    const current = Number(input.value || 1);
    const next = qtyButton.dataset.qtyButton === 'plus' ? current + 1 : Math.max(1, current - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const thumbButton = event.target.closest('[data-product-thumb]');
  if (thumbButton) {
    const mainImage = document.querySelector('[data-product-main-image]');
    if (!mainImage) return;
    mainImage.src = thumbButton.dataset.productImage;
    mainImage.srcset = thumbButton.dataset.productSrcset || '';
    mainImage.alt = thumbButton.dataset.productAlt || '';
  }
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.15 });

document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
